module.exports = __webpack_public_path__ + "media/images/athletes/1358-796c1a042c2bd01ecaf1ca9447f71cdc.png";